<template>
  <div class="table-limit">
    <span class="table-limit__text">Records per page:</span>
    <app-select
      @input="onUpdate"
      v-model="limit_selected"
      :options="limit_options"
      :filterable="false"
      :clearable="false"
      :searchable="false"
      placeholder="Select option"
      class="select--small"
    />
  </div>
</template>

<script>

export default {
  name: 'AppTableLimit',
  props: {
    limit: {
      type: Number,
      required: false,
      default: 20
    }
  },
  data() {
    return {
      limit_selected: { name: this.limit },
      limit_options: [
        { name: 20 },
        { name: 40 },
        { name: 60 },
        { name: 80 },
        { name: 100 },
      ],
    }
  },
  methods: {
    onUpdate(data) {
      this.limit_selected.name = data.name
      this.$emit('update-limiter', data.name)
    },
  }
}
</script>

<style scoped lang="sass">
.table-limit
  display: flex
  align-items: center
  gap: 10px

.table-limit__text
  color: $color-text-second
  font-size: 13px
</style>
